import { ISDKConfig } from '@kollective-frontend/ksdk-api';
export default class SDKConfig implements ISDKConfig {
  version: string | undefined;
  gitCommit: string | undefined;
  integration: { name: string };
  reportInterval: number;

  constructor(integration?: { name: string }, reportInterval?: number) {
    this.version = process.env.npm_package_version;
    this.gitCommit = process.env.GIT_COMMIT_SHORT;

    if (integration?.name) {
      this.integration = integration;
    } else {
      this.integration = { name: 'ksdk' };
    }
    this.reportInterval = 300000;
    if (reportInterval && reportInterval > 0) {
      this.reportInterval = reportInterval;
    }
  }

  setIntegration(integration: { name: string }): SDKConfig {
    if (integration?.name) {
      this.integration = integration;
    }
    return this;
  }

  setReportInterval(interval: number): SDKConfig {
    if (interval && interval > 0) {
      this.reportInterval = interval;
    }
    return this;
  }

  /**
   * @returns the integration name
   */
  integrationName(): string {
    return this.integration.name;
  }
}
